export class VehicleStatus {
    static readonly IN_TRANSIT: string = 'IN-TRANSIT';
}



// WEBPACK FOOTER //
// ./node_modules/@nw/ui-watchlist/shared/constants/vehicle-status.ts